import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { onCancelGame } from '../../../state-actions/onCancelGame';
import { onRestartGame } from '../../../state-actions/onRestartGame';
import { onNextGame } from '../../../state-actions/onNextGame';
import EndGameButtonStyled, {
  EndGameButtonWrap,
  Text,
} from './EndGameButton.styled';
import IconRestart from '../IconRestart/IconRestart';
import IconNext from '../IconNext/IconNext';
import IconMenu from '../IconMenu/IconMenu';

const mapDispatchToProps = dispatch => ({
  onCancelGame: viewing => dispatch(onCancelGame(viewing)),
  onRestartGame: bool => dispatch(onRestartGame(bool)),
  onNextGame: bool => dispatch(onNextGame(bool)),
});

export const EndGameButton = ({
  text,
  onCancelGame,
  onRestartGame,
  onNextGame,
}) => {
  switch (text) {
    case 'restart':
      return (
        <EndGameButtonWrap>
          <EndGameButtonStyled onClick={() => onRestartGame(true)}>
            <IconRestart />
            <Text>Restart</Text>
          </EndGameButtonStyled>
        </EndGameButtonWrap>
      );
    case 'next':
      return (
        <EndGameButtonWrap>
          <EndGameButtonStyled onClick={() => onNextGame(true)}>
            <IconNext />
            <Text>Next</Text>
          </EndGameButtonStyled>
        </EndGameButtonWrap>
      );
    case 'menu':
      return (
        <EndGameButtonWrap>
          <EndGameButtonStyled
            id="return-to-menu"
            onClick={() => onCancelGame('selector')}
          >
            <IconMenu />
            <Text>Menu</Text>
          </EndGameButtonStyled>
        </EndGameButtonWrap>
      );
    default:
      return 'End';
  }
};

export default connect(
  null,
  mapDispatchToProps
)(EndGameButton);

EndGameButton.propTypes = {
  text: PropTypes.string.isRequired,
  onCancelGame: PropTypes.func,
  onRestartGame: PropTypes.func,
  onNextGame: PropTypes.func,
};

EndGameButton.defaultProps = {
  onCancelGame: null,
  onRestartGame: null,
  onNextGame: null,
};



// WEBPACK FOOTER //
// ./src/components/atoms/EndGameButton/EndGameButton.js